import React, { useContext, createContext, useState,Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { connect } from "react-redux";
import BaseRouter from "./routes";
import * as actions from "./store/actions/auth";
import CustomLayout from "./containers/Layout";
import UserLayout from "./containers/UserLayout";
import CreateCV from "./containers/pages/formCreateCV/createCV";
import Cookies from "universal-cookie";
const cookies = new Cookies;

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
      // this.fetchUserInfo();
  }
  // fetchUserInfo = ()=>{
  //     authAxios(cookies.get('token'))
  //       .get(userIDURL).then(res=>{
  //   })
  // }

  render() {
     return (
         <Router>
            <Switch>
                <Route exact path="/cv/:link_cv" component={CreateCV} />
                <Route exact path="/login" component={UserLayout} />
                <CustomLayout {...this.props}>
                    <BaseRouter />
                </CustomLayout>
            </Switch>
        </Router>
     )
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
